require("./page.scss");
import { Hero } from '../../Hero/Assets/hero-assets.js';
import { ComparisonTable } from '../../../Shared/Assets/comparisonTable.js';
require("../../../Shared/Assets/lightbox-assets.js");

class BadgeCompare {
    init() {
        this.initProperties();
        this.heroManager.initVideo();
        this.comparisonTable.init();

        window.addEventListener("resize", this.onResize); 
    }

    initProperties = () => {
        this.hero = document.querySelector('[data-role="hero"]');
        this.heroManager = new Hero();
        this.comparisonTable = new ComparisonTable();
    }

    onResize = () => {
        this.heroManager.onResize();
    }
}

const badgeCompare = new BadgeCompare();

window.addEventListener("load", () => badgeCompare.init());


